import React, {useState, useEffect, Fragment} from "react";
import { isAuthenticated, setTheme } from "./helper";
import { Link, useHistory } from "react-router-dom";
import {signout} from "../screens/helper"
import {FacebookShareCount, FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, WhatsappShareButton, WhatsappIcon, LineShareButton, LinkedinIcon, TelegramShareButton, TelegramIcon, LinkedinShareButton} from "react-share"
import M from "materialize-css"
import $ from "jquery"
import AppTheme from "../colors";
import {Sugar} from 'react-preloaders';

const Home = () => {
    
    
        document.addEventListener('DOMContentLoaded', function() {
            var elems = document.querySelectorAll('.modal');
            var instances = M.Modal.init(elems, {});
          });
    
    
    const theme = JSON.parse(localStorage.getItem("theme"));
    // const currentTheme =  AppTheme[theme]
    // console.log(currentTheme);
    // const [themeMode, setThemeMode] = useState(theme);
    const currentTheme =  AppTheme["light"]
    // if(JSON.parse(localStorage.getItem("theme")) === "dark" && theme === "light"){
    //     window.location.reload()
    // }
    
    var like = true;
    const history = useHistory()
    const [comment, setComment] = useState("")
    const [post, setPost] =useState([]);
    const [likess, setLikes] = useState([]);
    const {user, token} = isAuthenticated()
    const [share, setShare] = useState("")
    const [loading, setLoading] = useState(true)
    const [isDel, setIsDel] = useState(false);
    
    useEffect(() => {
        if(user){
            fetch(`${process.env.REACT_APP_BACKEND}/user/${user._id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then(res => res.json())
            .then(data => {
                if(!data.isDeleted){
                    var existing = JSON.parse(localStorage.getItem("jwt"));
                    existing.user.isDeleted = 0;
                    localStorage.setItem("jwt", JSON.stringify(existing));
                    fetch(`${process.env.REACT_APP_BACKEND}/allpost`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                    .then(res=> res.json())
                    .then(data => {
                        console.log(data);
                        setLoading(false)
                        setPost(data)
                        
                        
                    })
                    .catch(err => console.log(err))
                    if(JSON.parse(localStorage.getItem("theme")) === "dark"){
                        localStorage.setItem("theme", JSON.stringify("light"));
                    }
                }
                else{
                    var existing = JSON.parse(localStorage.getItem("jwt"));
                    existing.user.isDeleted = 1;
                    localStorage.setItem("jwt", JSON.stringify(existing));
                    setLoading(false);
                    setIsDel(true);
                }
            })
        }
        
        
    }, [])

    

    const likePost = (id) => {
        
        if(like){
            
            like = false;
            fetch(`${process.env.REACT_APP_BACKEND}/like/${user._id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    postId: id
                })
            })
            .then(res=> res.json())
            .then(data => {
                console.log(data);
                const newPost = post.map(item => {
                    if(item._id == data._id){
                        return data
                    }
                    else{
                        return item
                    }
                })
                setPost(newPost)
                
            })
            .catch(err => console.log(err))
        }
        
    }
    const unLikePost = (id) => {
        fetch(`${process.env.REACT_APP_BACKEND}/unlike/${user._id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                postId: id
            })
        })
        .then(res=> res.json())
        .then(data => {
            const newPost = post.map(item => {
                if(item._id == data._id){
                    return data
                }
                else{
                    return item
                }
            })
            setPost(newPost)
        })
        .catch(err => console.log(err))
    }

    const makeComment = (text, postId) => {
        if(text.length === 0){
            return;
        }
        fetch(`${process.env.REACT_APP_BACKEND}/comment/${user._id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                postId,
                text
            })
        })
        .then(res => res.json())
        .then(data => {
            console.log(data)
            const newPost = post.map(item => {
                if(item._id == data._id){
                    return data
                }
                else{
                    return item
                }
            })
            setPost(newPost)
            setComment("")
        })
        .catch(err => console.log(err))
    }

    const deletePost = (postId) => {
        fetch(`${process.env.REACT_APP_BACKEND}/delete/${postId}/${user._id}`, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
        .then(res=>res.json())
        .then(result => {
            console.log(result)
            const newData = post.filter(item => {
                return item._id !== result._id
            })  
            setPost(newData)
        })
        .catch(err => console.log(err))
    }

    const deleteComment = (postId, commentId) => {
        fetch(`${process.env.REACT_APP_BACKEND}/deletecomment/${postId}/${commentId}/${user._id}`, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(data => {
            console.log(data)
            const newPost = post.map(item => {
                if(item._id == data._id){
                    return data
                }
                else{
                    return item
                }
            })
            setPost(newPost)
        })
        .catch(err => console.log(err))
    }

    const viewLike = (id) => {
        fetch(`${process.env.REACT_APP_BACKEND}/likes/${user._id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                postId: id
            })
        })
        .then(res=> res.json())
        .then(dataa => {
            
            console.log(dataa);
            setLikes(dataa.likes);
            
            
        })
        .catch(err => console.log(err))
    }

    const report = (id) => {
        fetch(`${process.env.REACT_APP_BACKEND}/report/${user._id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                postId: id
            })
        })
        .then(res=> res.json())
        .then(data => {
            M.toast({html: 'Thanks for reporting',classes:"#c62828 red darken-3"});  
            console.log(data);
            const newPost = post.map(item => {
                if(item._id == data._id){
                    return data
                }
                else{
                    return item
                }
            })
            setPost(newPost)
            // var toastHTML = '<span>I am toast content</span><button class="btn-flat toast-action">Undo</button>';
            
        })
        .catch(err => console.log(err))
    }

    const shareit = (postId) => {
        const url = `https://socioroorkee.netlify.app/post/${postId}`
        setShare(url)
    } 

    return (
        <>
        {!isDel ? (
        <Fragment>
        {post && theme ? (
            <div className="row" style={{backgroundColor: `${currentTheme.backgroundColor}`}}>
            <div className="col s12">
                <div className="home">
                {
                    post.map(item => {
                        return( 
                            <Fragment>
                            {item.reports.includes(user._id) ? (
                                " "
                            ) : (
                            <div className="card home-card"  key={item._id} style={{backgroundColor: `${currentTheme.navColor}`, color: `${currentTheme.textColor}`}}>
                                <h5 style={{textAlign:"left", marginLeft: "3%"}}>
                                    <div className="row">
                                        <div className="col s2">
                                            <img className="circle" height="40" width="40" style={{marginTop: "5px", marginRight: "5px"}} src={item.postedBy.pic}/>
                                        </div>
                                        <div className="col s5" style={{paddingTop: "2%", marginLeft: "-3%"}}>
                                            <Link to={item.postedBy._id !== user._id ? `/profile/${item.postedBy._id }` : "/profile"}>
                                            <span style={{paddingTop: "2%" ,color: `${currentTheme.textColor}`}}>{item.postedBy.name}</span>
                                            </Link>
                                            </div>
                                        <div className="col s5">
                                            <i className="material-icons right modal-trigger" data-target="modal3" style={{float:"right", paddingTop: "3%", paddingRight: "2%"}} onClick={() => {shareit(item._id)}}>share</i>

                                            <i className="material-icons right" style={{float:"right", paddingTop: "3%"}} onClick={() => {report(item._id)}}>report</i>
                                                
                                            {item.postedBy._id === user._id || user.role === 1 ? (
                                                <i className="material-icons right" style={{float:"right", paddingTop: "3%"}}
                                                onClick={() => deletePost(item._id)} >delete</i>
                                            ) : ""}
                                        </div>
                                    </div>
                                    

                                    

                                    
                                
                                </h5>
                                <div className="card-image" >
                                    <img src={item.photo}/>
                                </div>
                                <div className="card-content">
                                    
                                    {item.likes.includes(user._id) ? (
                                        
                                        <div className="heart like is-active"  onClick={() => unLikePost(item._id)}></div>
                                    ) : (
                                        
                                        <div className="heart unlike" onClick={() => likePost(item._id)}></div>
                                    )}
                                    
                                    
                                    <h6 data-target="modal2" className="modal-trigger" onClick={() => viewLike(item._id)} style={{cursor: "pointer"}}>{item.likes.length} likes</h6>
                                    <h6>{item.title}</h6>
                                    <p>{item.body}</p>
                                    <p>{item.comments.length} comments</p>
                                    {
                                        item.comments.map(record => {
                                            return (
                                                <h6 key={record._id}><span style={{fontWeight: "700"}}>{record.postedBy.name}</span> {record.text} 
                                                {record.postedBy._id === user._id || user.role === 1 ? (
                                                    <i className="material-icons right" 
                                                    onClick={() => deleteComment(item._id, record._id)} >delete</i> 
                                                ) : ""}
                                                
                                                
                                                </h6>
                                            )
                                        })
                                    }   
                                    
                                    <form onSubmit={(e)=>{
                                        e.preventDefault()
                                        
                                        makeComment(comment, item._id)
                                    }}>
                                        <input type="text" placeholder="add a comment" value={comment} 
                                        onChange={(e) => {setComment(e.target.value)}} style={{color: `${currentTheme.textColor}`}} />
                                    </form>
                                    
                                </div>
                            </div>
                            ) }
                            </Fragment>
                        )
                    })
                }
                <div id="modal2" className="modal">
                    <div className="modal-content" style={{backgroundColor: `${currentTheme.navColor}`}}>
                    <h4><span style={{color: `${currentTheme.textColor}`}}>Post Liked By:</span></h4>
                    <ul className="collection">
                        {likess.map(like => {
                            return (
                                <li className="collection-item" key={like._id}>
                                <div className="row p0">
                                <div className="col s3 p0">
                                <img className="circle" height="40" width="40" style={{marginTop: "5px", marginRight: "5px"}} src={like.pic}/> 
                                </div>
                                <div className="col s9 p0">
                                <span style={{fontSize: "25px"}}>{like.name}</span>
                                </div>
                                </div>
                                
                                
                                
                                </li>
                            )
                        })}
                    </ul>
                    </div>
                    <div className="modal-footer" style={{backgroundColor: `${currentTheme.navColor}`, }}>
                    <button className="modal-close waves-effect waves-green btn-flat"><span style={{color: `${currentTheme.textColor}`}}>CLOSE</span></button>
                    </div>
                </div>
                <div id="modal3" className="modal" style={{color: "black"}}>
                    <div className="modal-content" style={{backgroundColor: `${currentTheme.navColor}`}}>
                    <h4><span style={{color: `${currentTheme.textColor}`}}>Share:</span></h4>
                    <ul className="collection">
                    <li className="collection-item ">
                        <div className="row ">
                            <div className="col l4 valign-wrapper center-align">
                            <FacebookShareButton url={share} className="ml-3"><FacebookIcon size={40} round={true}></FacebookIcon></FacebookShareButton>
                            </div>
                            <div className="col l4">
                            <TwitterShareButton url={share}><TwitterIcon size={40} round={true}></TwitterIcon></TwitterShareButton>
                            </div>
                            <div className="col l4"><WhatsappShareButton url={share}><WhatsappIcon size={40} round={true}></WhatsappIcon></WhatsappShareButton></div>
                            <div className="col l4"><LinkedinShareButton url={share}><LinkedinIcon size={40} round={true}></LinkedinIcon></LinkedinShareButton></div>
                            <div className="col l4"><TelegramShareButton url={share}><TelegramIcon size={40} round={true}></TelegramIcon></TelegramShareButton></div>
                        </div>
                    </li>
                        
                    </ul>
                    </div>
                    <div className="modal-footer" style={{backgroundColor: `${currentTheme.navColor}`, }}>
                    <button className="modal-close waves-effect waves-green btn-flat"><span style={{color: `${currentTheme.textColor}`}}>CLOSE</span></button>
                    </div>
                </div>
                </div>
            </div>
                <div class="fixed-action-btn">
                    <Link class="btn-floating btn-large blue" to="/create">
                        <i class="large material-icons">add</i>
                    </Link>
                </div>
                {loading && 
                    <div className="preloader-background" >
                    <div class="preloader-wrapper active" style={{backgroundColor: `${currentTheme.backgroundColor}`}}>
                        <div class="spinner-layer spinner-blue-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div><div class="gap-patch">
                            <div class="circle"></div>
                        </div><div class="circle-clipper right">
                            <div class="circle"></div>  
                        </div>
                        </div>
                    </div>
                    </div>
                
                }
        </div>
        
        ) : (
            ""
        ) }
        
        </Fragment>
        ) : (
            <>
            <h1>Your Account has been deleted, Please logout</h1>
            <Link onClick={() => {
                signout(() => {
                    history.push("/login")
                    window.location.reload()
                })
            }} to="/login" className="sidenav-close" >Signout</Link>
            </>
        ) }
        </>
    )
}

export default Home;